
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { handleValueShow } from './widget/valueConfig';
@Component({
	name: 'cell',
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop() public value!: any;
	private get field() {
		if (this.item.fieldType === 'associationField') {
			return this.item.sourceField;
		}
		return this.item;
	}
	private get valueShow() {
		return handleValueShow(this.value, this.item);
	}
}
